export default "__VITE_ASSET__69b1bf26__"